export enum Currency {
  CanadianDollar = 'CAD',
  SwissFranc = 'CHF',
  Euro = 'EUR',
  PoundSterling = 'GBP',
  SwedishKrona = 'SEK',
  USDollar = 'USD',
}
